'use strict';

import './component.scss';
import isEnterOrSpacebarPressed from 'components/complement/isEnterOrSpacebarPressed';

const LIGHT_BOX_SELECTOR = '[data-component="light-box"]';

function initElement(element)
{
    if (element.dataset.lightBoxInitialized !== undefined) {
        return;
    }

    if (element.checked) {
        setTimeout(() => {
            let detail = element.nextElementSibling.nextElementSibling;
            element.dispatchEvent(new CustomEvent('light-box:open', {detail, bubbles: true}));
        }, 10);
    } else {
        element.classList.remove('animate');
    }

    let elementId = element.id,
        elementTrigger = document.querySelector(`label[for="${elementId}"]`);

    if (!elementTrigger.hasAttribute('data-skip-lightbox-keydown')) {
        elementTrigger.addEventListener('keydown', event => {
            isEnterOrSpacebarPressed(event)
                && !elementTrigger.hasAttribute('aria-expanded') // if not a panel toggler
                    && elementTrigger.click();
        });
    }

    element.addEventListener('click', event => {
        let toggler = event.target,
            detail = toggler.nextElementSibling.nextElementSibling;
        if (toggler.checked) {
            toggler.dispatchEvent(new CustomEvent('light-box:opening', {detail, bubbles: true}));
            requestAnimationFrame(() => {
                toggler.classList.add('animate');
            });
        } else {
            toggler.dispatchEvent(new CustomEvent('light-box:closing', {detail, bubbles: true}));
        }
    });

    let lightBox = element.nextElementSibling;
    lightBox.addEventListener('transitionend', event => {

        let toggler = event.target.previousElementSibling,
            detail = toggler.nextElementSibling.nextElementSibling;

        if (toggler.checked) {
            toggler.dispatchEvent(new CustomEvent('light-box:open', {detail, bubbles: true}));
        } else {
            toggler.dispatchEvent(new CustomEvent('light-box:close', {detail, bubbles: true}));
            toggler.classList.remove('animate');
            focusTogglerLabelAfterModalClose(toggler);
        }
    });

    element.dataset.lightBoxInitialized = '';
}

function focusTogglerLabelAfterModalClose(toggler)
{
    let labelHook = `[for="${toggler.id}"]`,
        modalLabel = document.querySelector(labelHook);

    if (modalLabel) {
        modalLabel.focus();
    }
}

function init0()
{
    document.addEventListener('keydown', onKeyDown);

    init(document.querySelectorAll(LIGHT_BOX_SELECTOR));
}

function onKeyDown(e) {
    const code = e.keyCode ? e.keyCode : e.which;

    if (code === 27) {      // ESC keycode
        for (const element of document.querySelectorAll(LIGHT_BOX_SELECTOR)) {
            element.checked = false;
        }
    }
}

function init(elements)
{
    for (const element of elements || document.querySelectorAll(LIGHT_BOX_SELECTOR)) {
        initElement(element);
    }
}

function create(id, cls)
{
    return `<input data-component="light-box"
       type="checkbox"
       name="${id}"
       id="${id}-toggler"
       value="yes"
       class="${cls ? cls + '-toggler ' : ''}light-box-toggler"
       autocomplete="off"/>
<label class="light-box${cls ? ' ' + cls + '-light-box' : ''}" for="${id}-toggler"></label>`;
}

window.addEventListener('DOMContentLoaded', init0);

export default {init0, init, create};
